import Button from 'react-bootstrap-button-loader';
import React, { Fragment, useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const initialClienteData = {
    nombre: '',
    apellido: '',
    correo: '',
    telefono: ''
};

const ClienteForm = (props) => {
    
    const id = props.match?.params?.id; 
    const isEditing = !!id;
    
    const [clienteData, setClienteData] = useState(initialClienteData);
    const [pass, setPass] = useState({ pass: '', new: '', confirm: '' });
    const [errorPass, setErrorPass] = useState(false);
    
    useEffect(() => {
        if (isEditing) {
        }
    }, [id, isEditing]);

    const handleDataChange = (e) => {
        setClienteData({ ...clienteData, [e.target.name]: e.target.value });
    };

    const handlePassChange = (name, value) => {
        setPass(prevPass => ({ ...prevPass, [name]: value }));
    };

    const guardarCliente = () => {
        toast.success(`Cliente ${isEditing ? 'actualizado' : 'creado'} exitosamente.`)
        props.history.push(`${process.env.PUBLIC_URL}/clientes`);
    };

    const setPassword = async () => {
        if (pass.pass.length > 4 && pass.new.length > 4 && pass.confirm.length > 4) {
            setErrorPass(false);
            
            toast.success('Contraseña del cliente cambiada.');
            setPass({ pass: '', new: '', confirm: '' });
        } else {
            setErrorPass(true);
            toast.warn('La contraseña debe tener un mínimo de 5 caracteres.');
        }
    };

    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">

                    <div className="col-sm-12 col-xl-12 xl-100">
                        <div className="card height-equal mt-2">
                            <div className="card-body">
                            <button 
                            className="btn btn-outline-light-2x txt-dark mb-4"
                            onClick={() => {
                                if (typeof props.setPag_agregar === 'function') {
                                    props.setPag_agregar(false);
                                } else if (props.history?.push) {
                                    props.history.push(`${process.env.PUBLIC_URL}/clientes`);
                                }
                            }} >
                                <i className="icofont icofont-arrow-left"/>Regresar
                            </button>
                                
                                
                                <h4 className='pb-4'><strong>Nuevo cliente</strong></h4>
                                <div className="row">
                                    <div className="form-group col-sm-6">
                                        <label className="form-label">Nombre (s)</label>
                                        <input className="form-control" name="Nombre (s)" value={clienteData.nombre} onChange={handleDataChange} />
                                    </div>
                                    <div className="form-group col-sm-6">
                                        <label className="form-label">Apellido (s)</label>
                                        <input className="form-control" name="Apellido (s)" value={clienteData.apellido} onChange={handleDataChange} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="form-group col-sm-6">
                                        <label className="form-label">Correo</label>
                                        <input className="form-control" name="correo" value={clienteData.correo} onChange={handleDataChange} />
                                    </div>
                                    <div className="form-group col-sm-6">
                                        <label className="form-label">Teléfono</label>
                                        <input className="form-control" name="telefono" value={clienteData.telefono} onChange={handleDataChange} />
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-sm-12 text-right">
                                        <button className="btn btn-success" onClick={guardarCliente}>
                                            Guardar Cliente
                                        </button>
                                    </div>
                                </div>
                                
                                <hr className="mt-4 mb-4" /> 


                                <h5 className="mb-3">Contraseña (Acceso del Cliente)</h5>

                                <div className="row">
                                    
                                    <div className="form-group col-sm-6">
                                        <label className="form-label">Nueva Contraseña</label>
                                        <input className="form-control" type="password" value={pass.new} onChange={e => handlePassChange('new', e.target.value)} />
                                        <small className="form-text text-success" style={{ color: '#4CAF50' }}>mínimo 5 caracteres</small>
                                    </div>
                                    
                                    <div className="form-group col-sm-6">
                                        <label className="form-label">Confirmar Contraseña</label>
                                        <input className="form-control" type="password" value={pass.confirm} onChange={e => handlePassChange('confirm', e.target.value)} />
                                        <small className="form-text text-success" style={{ color: '#4CAF50' }}>mínimo 5 caracteres</small>
                                    </div>
                                    
                                    <div className="col-sm-12 mt-3">
                                        {errorPass && <a className="text-danger mb-2 d-block text-center">Completa todos los datos de contraseña correctamente (mínimo 5 caracteres).</a>}
                                        <button className="btn btn-primary" onClick={setPassword}>
                                            Reenviar Contraseña
                                        </button>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default ClienteForm;
